import React from 'react';
import PermissionsContainer from '../../../components/PermissionsContainer';
import { ORDER_LC_FIELDS_COMPONENT_ID } from '../useCanEditOrderLcFields';

/**
 * Wraps a group of LC-only ORDER fields (Port of Origin/Discharge, DC, Dept).
 *
 * On an order it renders inside the `order-lc-fields` PermissionsContainer, which draws
 * the permissions frame (permissions mode, developer only) and self-registers the
 * component so an admin can grant LC groups edit access. On a template it renders the
 * children directly — templates are gated by the template-edit gate (see
 * useCanEditTemplateFields), not this one, and must not draw a second frame.
 *
 * NOTE: this group is used at ~10 call sites (OrderFormView, AddlInfoView,
 * InvoicingView), so one permission owns several disconnected frames. That's expected —
 * PermissionConfigurable cross-highlights co-scoped frames and reports the region count
 * so a single frame isn't mistaken for the permission's whole scope.
 *
 * The per-field editable/read-only decision is made by the caller
 * (useCanEditOrderLcFields for the order branch); this component only anchors the
 * frame + registration, so template rendering stays untouched.
 */
const OrderLcFieldGroup: React.FC<{ isTemplate: boolean; children: React.ReactNode }> = ({
  isTemplate,
  children,
}) =>
  isTemplate ? (
    <>{children}</>
  ) : (
    <PermissionsContainer
      componentId={ORDER_LC_FIELDS_COMPONENT_ID}
      componentName="LC Order Fields"
      defaultDisabled
    >
      {children}
    </PermissionsContainer>
  );

export default OrderLcFieldGroup;
